import { Box, Flex, GridItem, Heading, VisuallyHidden } from '@chakra-ui/react'
import { ContentfulLivePreview } from '@contentful/live-preview'
import { BLOCKS } from '@contentful/rich-text-types'
import ContentfulImage from '~/components/shared-components/ContentfulImage/ContentfulImage'
import DocumentToReactRender from '~/components/shared-components/DocumentToReactRender/DocumentToReactRender'
import { IIconBanner } from '~/types/generated/contentful'

import ContainerGrid from '../../grid/ContainerGrid/ContainerGrid'

export default function IconBannerModule({
  componentData,
}: {
  componentData: IIconBanner
}) {
  const {
    title,
    showTitle,
    items,
    darkBackground = true,
  } = componentData.fields

  return (
    <Box
      className="icon-banner"
      as="section"
      bg={darkBackground ? 'primary.darkGreen.100' : 'primary.white.100'}
      color={darkBackground ? 'primary.white.100' : 'primary.teal.100'}
      py={{ base: '60px', lg: '72px' }}
    >
      <ContainerGrid>
        <GridItem
          colStart={{ base: 1, md: 3, lg: 2 }}
          colSpan={{ base: 12, md: 8, lg: 10 }}
        >
          <Flex
            direction={{ base: 'column' }}
            justifyContent="center"
            alignItems={{ base: 'center' }}
            gap="44px"
            w="100%"
          >
            {showTitle ? (
              <Heading
                as="h2"
                variant="subheading"
                color={darkBackground ? 'inherit' : '#767676'}
                {...ContentfulLivePreview.getProps({
                  entryId: componentData.sys.id,
                  fieldId: 'title',
                })}
              >
                {title}
              </Heading>
            ) : (
              <VisuallyHidden>
                <Heading
                  as="h2"
                  variant="subheading"
                  color={darkBackground ? 'inherit' : '#767676'}
                  {...ContentfulLivePreview.getProps({
                    entryId: componentData.sys.id,
                    fieldId: 'title',
                  })}
                >
                  {title}
                </Heading>
              </VisuallyHidden>
            )}
            <Flex
              direction={{ base: 'column', lg: 'row' }}
              justifyContent="space-between"
              w="100%"
              gap={{ base: '40px', xl: '90px' }}
            >
              {items?.map((item, index) => (
                <Flex
                  key={`${item.sys.id}-${index}`}
                  direction="column"
                  gap="24px"
                  px={{ base: '15px', md: 0 }}
                  justify={{ base: 'center', md: 'left' }}
                  w="100%"
                >
                  {item.fields.image && (
                    <ContentfulImage
                      image={item.fields.image}
                      overrideValues={{
                        height: 100,
                      }}
                    />
                  )}

                  {item.fields?.richHeading && (
                    <DocumentToReactRender
                      componentData={item.fields.richHeading}
                      color="inherit"
                      fieldId="richHeading"
                      entryId={item.sys?.id}
                      options={{
                        renderNode: {
                          [BLOCKS.PARAGRAPH]: (node, children) => (
                            <Heading
                              as="h3"
                              variant="H3B"
                              minH={{ lg: '80px' }}
                              data-tag="paragraph"
                            >
                              {children}
                            </Heading>
                          ),
                        },
                      }}
                    />
                  )}

                  <DocumentToReactRender
                    componentData={item.fields.description}
                    color="inherit"
                    fieldId="description"
                    entryId={item.sys?.id}
                  />
                </Flex>
              ))}
            </Flex>
          </Flex>
        </GridItem>
      </ContainerGrid>
    </Box>
  )
}
